import React, { PropTypes } from 'react';
import { connect } from 'react-redux';
import ObservationSetup from '../components/ObservationSetup';
import { fetchStudents } from '../actions/students';
import { doFlash } from '../actions/flash';
import Preferences from '../lib/preferences';
import moment from 'moment';
import { createObservation, fetchRecentObservations } from '../actions/observations';
import { fetchTeachers } from '../actions/classrooms';
import { fetchGradeLevels } from '../../../a2i/js/actions/gradeLevels';
import { propertyHasChanged } from '../../../a2i/js/lib/objectComparison';

let ObservationSetupContainer = React.createClass({
	propTypes: {
		classroom: PropTypes.object,
		createObservation: PropTypes.func.isRequired,
		currentObservation: PropTypes.object,
		fetchGradeLevels: PropTypes.func.isRequired,
		fetchRecentObservations: PropTypes.func.isRequired,
		fetchStudents: PropTypes.func.isRequired,
		fetchTeachers: PropTypes.func.isRequired,
		gradeLevels: PropTypes.array,
		isFetchingObservations: PropTypes.bool,
		isFetchingStudents: PropTypes.bool,
		isFetchingTeachers: PropTypes.bool,
		// `isReliabilityObservation` can be handed in to this container to specify that this is a scored
		// reliability observation
		isReliabilityObservation: PropTypes.bool,
		recentObservations: PropTypes.array,
		students: PropTypes.array,
		teachers: PropTypes.array
	},

	contextTypes: {
		router: PropTypes.object.isRequired
	},

	componentDidMount: function() {
		if (this.props.classroom) {
			this.fetchStudents(this.props.classroom.id);
			this.props.fetchTeachers(this.props.classroom.id);
		}

		this.props.fetchGradeLevels();
	},

	componentWillReceiveProps: function(newProps) {
		if (newProps.classroom && propertyHasChanged(this.props.classroom, newProps.classroom)) {
			this.fetchStudents(newProps.classroom.id);
			this.props.fetchTeachers(newProps.classroom.id);
		}
	},

	fetchStudents: function(classroomId) {
		this.props.fetchStudents({ classroom_id: classroomId, results_per_page: 9999 });
	},

	render: function() {
		return(
			<ObservationSetup
				classroom={ this.props.classroom }
				createObservation={ this.props.createObservation }
				currentObservation={ this.props.currentObservation }
				fetchGradeLevels={ this.props.fetchGradeLevels }
				fetchRecentObservations={ this.props.fetchRecentObservations }
				gradeLevels={ this.props.gradeLevels }
				isFetchingObservations={ this.props.isFetchingObservations }
				isFetchingStudents={ this.props.isFetchingStudents }
				isFetchingTeachers={ this.props.isFetchingTeachers }
				isReliabilityObservation={ this.props.isReliabilityObservation }
				recentObservations={ this.props.recentObservations }
				router={ this.context.router }
				students={ this.props.students }
				teachers={ this.props.teachers }
			/>
		);
	}
});

let mapStateToProps = function(state) {
	return {
		classroom: state.classrooms.selected,
		currentObservation: state.observations.current,
		gradeLevels: state.gradeLevels.list,
		isFetchingObservations: state.observations.isFetching,
		isFetchingStudents: state.students.isFetching,
		isFetchingTeachers: state.classrooms.isFetchingTeachers,
		recentObservations: state.observations.recent,
		students: state.students.list,
		teachers: state.classrooms.teachers
	};
};

let mapDispatchToProps = {
	createObservation,
	doFlash,
	fetchGradeLevels,
	fetchRecentObservations,
	fetchStudents,
	fetchTeachers
};

module.exports = connect(mapStateToProps, mapDispatchToProps)(ObservationSetupContainer);



// WEBPACK FOOTER //
// ./frontend/olos/js/containers/ObservationSetup.jsx